export const GET_REJECTIONS_REPORT_REQUEST = "GET_REJECTIONS_REPORT_REQUEST";
export const GET_REJECTIONS_REPORT_SUCCESS = "GET_REJECTIONS_REPORT_SUCCESS";
export const GET_REJECTIONS_REPORT_FAILURE = "GET_REJECTIONS_REPORT_FAILURE";

export const GET_REJECTIONS_DOWNLOAD_REQUEST = "GET_REJECTIONS_DOWNLOAD_REQUEST";
export const GET_REJECTIONS_DOWNLOAD_SUCCESS = "GET_REJECTIONS_DOWNLOAD_SUCCESS";
export const GET_REJECTIONS_DOWNLOAD_FAILURE = "GET_REJECTIONS_DOWNLOAD_FAILURE";
 